import {
  ERROR_RESET,
  ERROR_SET,
  FETCH_2FA_ASYNC,
  LOGIN_STEPS,
  SUBMIT_2FA_ASYNC,
  SUBMIT_EXPIRED_PASS_ASYNC,
  SUBMIT_LOGIN_ASYNC,
  SUBMIT_SSO_ASYNC,
  USE_OTHER_CREDENTIALS_ASYNC,
  VALIDATE_SESSION_ASYNC,
} from './constants'

const f = () => {
  const initialState = {
    error: null,

    loginStep: LOGIN_STEPS.PASSWORD,
    loginLoader: false,
    loginSubmitLoader: false,

    timeTillUnblock: undefined,
    tfaParingUrl: undefined,
    ssoUrl: undefined,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case ERROR_SET:
        return {
          ...state,
          error: { detail: action.payload.error },
        }
      case ERROR_RESET:
        return {
          ...state,
          error: null,
        }

      case USE_OTHER_CREDENTIALS_ASYNC.INITIATE:
        return {
          ...state,
          loginLoader: true,
        }

      case USE_OTHER_CREDENTIALS_ASYNC.SUCCESS:
        return {
          ...state,
          loginStep: LOGIN_STEPS.PASSWORD,
          loginLoader: false,
        }

      case FETCH_2FA_ASYNC.INITIATE:
      case VALIDATE_SESSION_ASYNC.INITIATE:
        return {
          ...state,
          loginLoader: true,
        }

      case SUBMIT_LOGIN_ASYNC.INITIATE:
      case SUBMIT_EXPIRED_PASS_ASYNC.INITIATE:
      case SUBMIT_SSO_ASYNC.INITIATE:
      case SUBMIT_2FA_ASYNC.INITIATE:
        return {
          ...state,
          error: null,
          loginSubmitLoader: true,
        }
      case VALIDATE_SESSION_ASYNC.SUCCESS:
      case SUBMIT_LOGIN_ASYNC.SUCCESS:
      case SUBMIT_EXPIRED_PASS_ASYNC.SUCCESS:
      case SUBMIT_SSO_ASYNC.SUCCESS:
      case SUBMIT_2FA_ASYNC.SUCCESS:
      case FETCH_2FA_ASYNC.SUCCESS:
        return {
          ...state,
          /*
           * If the app needs to do a redirect
           * don't set loginStep to LOGIN_STEPS.LOGGED
           * to prevent SPA login processing
           */
          loginStep: action.payload.data.redirectTo
            ? state.loginStep
            : action.payload.data.step || state.loginStep,
          loginLoader: action.payload.data.step === LOGIN_STEPS.LOGGED,
          loginSubmitLoader: false,

          ssoUrl: action.payload.data.ssoUrl,
          timeTillUnblock: action.payload.data.ttl,
          tfaParingUrl: action.payload.data.url,
          eulaHTML: action.payload.data.terms,
        }
      case VALIDATE_SESSION_ASYNC.ERROR:
      case SUBMIT_LOGIN_ASYNC.ERROR:
      case SUBMIT_EXPIRED_PASS_ASYNC.ERROR:
      case SUBMIT_SSO_ASYNC.ERROR:
      case FETCH_2FA_ASYNC.ERROR:
      case SUBMIT_2FA_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          loginStep: action.error.response?.step || state.loginStep,
          loginLoader: false,
          loginSubmitLoader: false,
        }

      default:
        return state
    }
  }
}

export default () =>
  (state = f(), action) => {
    switch (action.type) {
      default:
        return state
    }
  }
